export default __webpack_public_path__ + "static/media/goshen49.edbb9318.jpg";